
import {merge as observableMerge, fromEvent as observableFromEvent, Observable, BehaviorSubject} from 'rxjs';

import {distinctUntilChanged, debounceTime,  map } from 'rxjs/operators';
import {Component , ElementRef , OnInit , ViewChild} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {EventTypeService} from '../../../../core/services/eventType.service';
import {DataSource} from '@angular/cdk/collections';
import {fuseAnimations} from '../../../../core/animations';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';



import {FuseUtils} from '../../../../core/fuseUtils';
import {FormGroup} from '@angular/forms';
import {EventTypeFormDialogComponent} from './setting-form/setting-form.component';

@Component({
    selector: 'event-settings-page',
    templateUrl: './event-settings.component.html',
    styleUrls: ['./event-settings.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class EventSettingsComponent implements OnInit {
  eventTypes: FilesDataSource | null;
  displayedColumns = [ 'name', 'color' ];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dialogRef: any;

  constructor (private http: HttpClient , private eventTypesService: EventTypeService , public dialog: MatDialog,  public snackBar: MatSnackBar ) {
  }

  ngOnInit () {
    this.getDataType();
  }

  getDataType () {
    this.eventTypes = new FilesDataSource(this.eventTypesService , this.paginator , this.sort);
    observableFromEvent(this.filter.nativeElement , 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.eventTypes) {
          return;
        }
        this.eventTypes.filter = this.filter.nativeElement.value;
      });
  }

  newType () {
    this.dialogRef = this.dialog.open(EventTypeFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        action: 'new'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (!response) {
          return;
        }
        const data = response[0].value;
        data.color = response[1];
        this.eventTypesService.addEventType(data).subscribe((res) => {
          if (res) {
            this.snackBar.open('Event type added.', '', {duration: 2500});
            this.eventTypesService.getEventTypes().then();
          }
        }, error => {
          this.snackBar.open('Add failed.', '', {duration: 2500});
        } );
      });

  }

  editType (type) {
    this.dialogRef = this.dialog.open(EventTypeFormDialogComponent , {
      panelClass: 'contact-form-dialog' ,
      width: '400px',
      data: {
        type: type ,
        action: 'edit'
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        // console.log(response);
        const actionType: string = response[ 0 ];
        const data = response[ 1 ].value;
        data.id = type.id;
        data.color = response[2];
        switch (actionType) {
          /**
           * Save
           */
          case 'save':


            this.eventTypesService.addEventType(data).subscribe((res) => {
              if (res) {
                this.snackBar.open('Event type updated.', '', {duration: 2500});
                this.eventTypesService.getEventTypes().then();
              }
            }, error => {
              this.snackBar.open('Update failed.', '', {duration: 2500});
            });
            break;
          /**
           * Delete
           */
          case 'delete':
            this.eventTypesService.deleteEventType(type.id).subscribe((res) => {
              if (res) {
                this.snackBar.open('Event type deleted.', '', {duration: 2500});
                this.eventTypesService.getEventTypes().then();
              }
            }, error => {
              this.snackBar.open('Delete failed.', '', {duration: 2500});
            });

            break;
        }
      });
  }
}

export class FilesDataSource extends DataSource<any> {
  _filterChange = new BehaviorSubject('');
  _filteredDataChange = new BehaviorSubject('');

  get filteredData (): any {
    return this._filteredDataChange.value;
  }

  set filteredData (value: any) {
    this._filteredDataChange.next(value);
  }

  get filter (): string {
    return this._filterChange.value;
  }

  set filter (filter: string) {
    this._filterChange.next(filter);
  }

  constructor (private cantonsService: EventTypeService ,
               private _paginator: MatPaginator ,
               private _sort: MatSort) {
    super();
    this.filteredData = this.cantonsService.eventTypes;
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect (): Observable<any[]> {
    const displayDataChanges = [
      this.cantonsService.onEventTypeChanged ,
      this._paginator.page ,
      this._filterChange ,
      this._sort.sortChange
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      let data = this.cantonsService.eventTypes.slice();

      data = this.filterData(data);

      this.filteredData = [ ...data ];

      data = this.sortData(data);

      // Grab the page's slice of data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      return data.splice(startIndex , this._paginator.pageSize);
    }));
  }

  filterData (data) {
    // console.log(data);
    if (!this.filter) {
      return data;
    }
    return FuseUtils.filterArrayByString(data , this.filter);
  }

  sortData (data): any[] {
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    return data.sort((a , b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'name':
          [ propertyA , propertyB ] = [ a.name , b.name ];
          break;


      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }

  disconnect () {
  }
}
